import { render, staticRenderFns } from "./CardLoader.vue?vue&type=template&id=527ee378&"
import script from "./CardLoader.vue?vue&type=script&lang=js&"
export * from "./CardLoader.vue?vue&type=script&lang=js&"
import style0 from "./CardLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports